'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Loadable from 'UIComponents/decorators/Loadable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIModal from 'UIComponents/dialog/UIModal';

const ErrorComponent = () => /*#__PURE__*/_jsx(UIErrorMessage, {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "errors.genericError"
  })
});

export const LoadingModal = () => /*#__PURE__*/_jsxs(UIModal, {
  children: [/*#__PURE__*/_jsx(UIDialogHeader, {
    children: /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "loading"
      })
    })
  }), /*#__PURE__*/_jsx(UIDialogBody, {
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered",
      className: "p-y-5"
    })
  })]
});
export const makeLoadableModal = loader => Loadable({
  loader,
  LoadingComponent: ({
    pastDelay
  }) => pastDelay && /*#__PURE__*/_jsx(LoadingModal, {}),
  ErrorComponent
});
export default (loader => Loadable({
  loader,
  LoadingComponent: ({
    pastDelay
  }) => pastDelay && /*#__PURE__*/_jsx(UILoadingSpinner, {
    layout: "centered",
    className: "p-y-5"
  }),
  ErrorComponent
}));